import { useCallback, useEffect, useMemo, useState } from 'react'
import * as com from '../Common'
import { getLoanOfficerLicenseStates } from './documentTemplateApi'

const ALL_LICENSE_STATES = Object.keys(com.mapAbbrFullName)
    .filter((state) => /^[A-Z]{2}$/.test(state))
    .sort()

const toStateOption = (state) => ({
    label: `${state} - ${com.mapAbbrFullName[state] || state}`,
    value: state,
})

export const useLoanOfficerLicenseStates = (enabled) => {
    const [configuredStates, setConfiguredStates] = useState([])
    const [loading, setLoading] = useState(Boolean(enabled))
    const [error, setError] = useState('')
    const [requestVersion, setRequestVersion] = useState(0)

    const retry = useCallback(() => {
        setRequestVersion((version) => version + 1)
    }, [])

    useEffect(() => {
        if (!enabled) return undefined

        const controller = new AbortController()
        setLoading(true)
        setError('')
        getLoanOfficerLicenseStates({ signal: controller.signal })
            .then(setConfiguredStates)
            .catch((requestError) => {
                if (requestError.name !== 'AbortError') {
                    setConfiguredStates([])
                    setError(
                        requestError.message ||
                            'Unable to load licensed states.'
                    )
                }
            })
            .finally(() => {
                if (!controller.signal.aborted) setLoading(false)
            })

        return () => controller.abort()
    }, [enabled, requestVersion])

    const states = configuredStates.length
        ? configuredStates
        : loading || error || !enabled
        ? []
        : ALL_LICENSE_STATES
    const options = useMemo(
        () => states.map(toStateOption),
        [states]
    )

    return {
        configuredStates,
        error,
        loading,
        options,
        retry,
        states,
    }
}
